import { render, staticRenderFns } from "./PassportPhotoUploader.vue?vue&type=template&id=aa39463a"
import script from "./PassportPhotoUploader.vue?vue&type=script&lang=ts"
export * from "./PassportPhotoUploader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports